import { useEffect, useState } from "react";
import { useDemoScenario } from "../../demo/DemoScenarioContext";
import { useT } from "../../i18n";
import "./DemoStreamFloat.css";

const formatTime = (date) =>
  `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;

export default function DemoStreamFloat() {
  const t = useT();
  const { mission } = useDemoScenario();
  const [now, setNow] = useState(() => new Date());
  const isLive = ["flying", "processing", "returning"].includes(mission?.phase);
  const streamSrc = `${process.env.PUBLIC_URL || ""}/demo/demo-drone-stream-v4.mp4`;

  useEffect(() => {
    if (!isLive) return undefined;
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, [isLive]);

  if (!isLive || !mission?.results?.length) return null;

  const phaseLabel =
    mission.phase === "flying"
      ? t("common.stream.badge.live")
      : t("common.stream.badge.returning");

  return (
    <div className="calm-stream-float demo-stream-float">
      <section className="drone-stream-viewer" aria-label={t("common.stream.demoAria")}>
        <div className="drone-stream-badge is-live">
          <span className="dot" />
          <span>{phaseLabel}</span>
        </div>
        <video className="demo-stream-video" autoPlay muted loop playsInline preload="auto">
          <source src={streamSrc} type="video/mp4" />
        </video>
        <div className="demo-stream-scan" aria-hidden="true" />
        {/* 카메라 OSD 흉내(기체명·고도·WP 카운터)는 영문 HUD 표기를 그대로 둔다. */}
        <div className="demo-stream-hud demo-stream-hud--top">TB_DRONE · CAM A</div>
        <div className="demo-stream-hud demo-stream-hud--bottom">
          <span>ALT 36m</span>
          <span>WP {Math.min(mission.completed + 1, mission.total)}/{mission.total}</span>
          <span>{formatTime(now)}</span>
        </div>
      </section>
    </div>
  );
}
